import { Result } from "antd";
import { useRouteError } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavButton } from "~/components/InternalLink";

export const SimpleErrorBoundary = () => {
  const { t } = useTranslation();
  const error = useRouteError();
  console.error("An error occured on this page", error);
  return (
    <Result status="500" title="500" subTitle={t("Sorry_something_went_wrong")}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <NavButton to="/" type="primary">
          Back Home
        </NavButton>
      </div>
    </Result>
  );
};
